import commonUtils from '../../utils/commonUtils';
import DefaultProgressNode from './entities/impl/DefaultProgressNode';
import { IProgressNode } from './entities/IProgressNode';

export function formatCycleData(rawCycles: any[]): IProgressNode[] {
  if (!rawCycles || !Array.isArray(rawCycles)) { 
    return []; 
  }
  const cycles: IProgressNode[] = [];
  for (const item of rawCycles) {
    const { date_value: date, tag_names: names } = item;
    const node = new DefaultProgressNode('', 0, names);
    if (!date) {
      continue;
    }
    node.date = date;
    const ms = Date.parse(node.date);
    if (isNaN(ms)) {
      continue;
    }
    node.time = ms;
    cycles.push(node);
  }
  return cycles;
}

export function formatNoBgCycleData(rawCycles: any[]): IProgressNode[] {
  if (!rawCycles || !Array.isArray(rawCycles)) { 
    return []; 
  }
  const cycles: IProgressNode[] = [];
  for (const item of rawCycles) {
    const { date_value: date, tag_names: names } = item;
    const node = new DefaultProgressNode('', 0, names);
    node.date = commonUtils.formatContent(date);
    node.time = 0;
    cycles.push(node);
  }
  return cycles;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSProgress/utils.ts